export default {
  title: 'Real Estate Market Statistics in Antalya Province',
  tabs: {
    sales: 'Property Sales',
    permits: 'Construction Permits'
  }
}
